import messages from "@/imports/data/errorMessages.js";
import {i18n} from '@/locales';

const GENERIC_ERROR = "Generic Error";

const errorMessages = {
  getErrorMessage: function(type, codeString, isAccountMessage = false) {
    if (isAccountMessage) {
      return i18n.t('errors.account.email');
    }
    if (messages[type]) {
      const code = this.getErrorCode(codeString);
      const text = this.getErrorText(codeString);
      if (messages[type][code]) {
        return i18n.t(`errors.${type}.${code}`, { msg: text });
      }
    }
    return i18n.t(GENERIC_ERROR);
  },
  getErrorCode: function(codeString) {
    const error = codeString.split('--');
    return String(error[0]);
  },
  getErrorText: function(codeString) {
    const error = codeString.split('--');
    return error[1];
  }
}

export default {
  install: function (Vue) {
    Vue.prototype.$errorMessages = errorMessages;
  }
}
